import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "svg-icon-AudioPlay",
  "use": "svg-icon-AudioPlay-usage",
  "viewBox": "0 0 10 12",
  "content": "<symbol viewBox=\"0 0 10 12\" xmlns=\"http://www.w3.org/2000/svg\" id=\"svg-icon-AudioPlay\"><path d=\"M10 6L0 11.77V.23z\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol